const steps = [
  { num: '01', title: 'Предварительный анализ', desc: 'Определяем бизнес-задачи и текущую ситуацию в компании.' },
  { num: '02', title: 'Диагностика', desc: 'Изучаем компетенции и потребности сотрудников.' },
  { num: '03', title: 'Проектирование', desc: 'Определяем содержание и формат программы.' },
  { num: '04', title: 'Обучение', desc: 'Проводим практическую программу.' },
  { num: '05', title: 'Практика', desc: 'Участники применяют навыки в реальной работе.' },
  { num: '06', title: 'Обратная связь', desc: 'Разбираем результаты и корректируем подходы.' },
  { num: '07', title: 'Оценка', desc: 'Определяем, какие изменения произошли.' },
  { num: '08', title: 'Сопровождение', desc: 'При необходимости продолжаем развитие команды.' },
];

export default function ProcessSection() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Как проходит работа с компанией
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          От бизнес-задачи до развития сотрудников — последовательность шагов, которая связывает обучение с результатом.
        </p>

        <div className="relative">
          <div className="absolute left-6 md:left-8 top-8 bottom-8 w-0.5 bg-teal-200 hidden md:block"></div>

          <div className="space-y-6 md:space-y-8">
            {steps.map((step, i) => (
              <div key={i} className="relative flex gap-5 md:gap-8 items-start">
                <div className="w-14 h-14 md:w-16 md:h-16 bg-teal-600 text-white rounded-xl flex items-center justify-center flex-shrink-0 relative z-10">
                  <span className="text-base md:text-lg font-extrabold">{step.num}</span>
                </div>
                <div className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 flex-grow">
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2">{step.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}